module.exports = __webpack_public_path__ + "static/google-play-badge-65e63f27fbcddd0fc446514a390b6530.png";